<template>
  <div class="mx-10 pt-10">
    <building-filters-vue v-if="codebooksLoaded" @refreshData="refreshData" />
    <building-table
      :refreshParams="refreshParams"
      @newBuilding="handleNewBuilding"
      @editBuilding="handleEditBuilding"
      @saveAssets="handleOpenSaveAsset"
      @uploadAssets="handleOpenUploadAsset"
      @comparativeOverview="handleComparativeOverview"
      @editDenied="handleEditDenied"
    />
    <v-dialog v-model="buildingDialog" persistent max-width="800px">
      <v-card>
        <v-toolbar color="primary" dense dark
          ><v-toolbar-title>Functional unit</v-toolbar-title
          ><v-spacer></v-spacer
          ><v-btn icon dark @click="buildingDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn></v-toolbar
        >
        <v-card-text class="pt-10">
          <BuildingForm
            @saveSuccess="handleSaveSuccess"
            @closeDialog="handleCloseBuildingDialog"
            :buildingData="buildingData"
            :buildingId="buildingId"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="saveAssetDialog" persistent max-width="400px">
      <v-card>
        <v-toolbar color="primary" dense dark>
          <v-toolbar-title>Save asset</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-information</v-icon>
            </template>
            <span
              >Save an asset for the selected functional units. Api request
              token and asset id that must be acquired from the Belit
              platform.</span
            >
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <SaveAssetsForm
            @submitAsset="handleSubmitAsset"
            :alertMessage="saveAssetAlertMessage"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="saveAssetDialog = false">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="uploadAssetDialog" persistent max-width="700px">
      <v-card min-height="600px">
        <v-toolbar color="primary" dense dark>
          <v-toolbar-title>Upload assets</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip left max-width="200">
            <template v-slot:activator="{ on }">
              <v-icon v-on="on">mdi-information</v-icon>
            </template>
            <span
              >Upload assets for the selected functional units. Api request
              token and asset id that must be acquired from the Belit
              platform.</span
            >
          </v-tooltip>
          <v-btn icon dark @click="uploadAssetDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="mt-5">
          <upload-assets-form
            @closeUploadDialog="handleCloseAssetDialog"
            @uploadAssetsFailed="handleUploadAssetsFailed"
            :selectedFunctionalUnits="selectedFunctionalUnits"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      timeout="3000"
      v-model="snackbarVisible"
      absolute
      :color="snackbarType"
      top
    >
      <div class="text-center">
        <h4>{{ snackbarMessage }}.</h4>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuildingFiltersVue from "../components/BuildingFilters.vue";
import BuildingTable from "../components/BuildingTable.vue";
import BuildingForm from "../components/BuildingForm.vue";
import SaveAssetsForm from "../components/SaveAssetsForm.vue";
import router from "../router/index";
import services from "../rest/Services";
import UploadAssetsForm from "../components/UploadAssetsForm.vue";

export default {
  name: "Dashboard",

  components: {
    BuildingTable,
    BuildingFiltersVue,
    BuildingForm,
    SaveAssetsForm,
    UploadAssetsForm,
  },
  data() {
    return {
      refreshParams: {},
      codebooksLoaded: false,
      buildingDialog: false,
      saveAssetDialog: false,
      snackbarVisible: false,
      snackbarType: "success",
      buildingData: null,
      buildingId: null,
      selectedFunctionalUnits: [],
      snackbarMessage: "",
      saveAssetAlertMessage: null,
      uploadAssetDialog: false,
    };
  },
  mounted() {
    this.getCodebooks();
  },
  methods: {
    refreshData: function (data) {
      this.refreshParams = data;
    },
    getCodebooks() {
      services
        .getCodebook()
        .then((response) => {
          sessionStorage.setItem("dbData", JSON.stringify(response.data));
          this.codebooksLoaded = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleNewBuilding: function () {
      this.buildingData = null;
      this.buildingId = null;
      this.buildingDialog = true;
    },
    handleEditBuilding: function (id) {
      const params = {
        functional_unit_id: id,
      };

      services
        .getFunctionalUnitById(params)
        .then((response) => {
          this.buildingId = id;
          this.buildingData = response.data;
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            console.log("error while fetching building");
          }
        });
      this.buildingDialog = true;
    },
    handleEditDenied: function (message) {
      this.setSnackbar(message, "error");
    },
    handleOpenSaveAsset: function (fUnitIds) {
      this.selectedFunctionalUnits = fUnitIds;
      this.saveAssetDialog = true;
    },
    handleOpenUploadAsset: function (fUnitIds) {
      this.selectedFunctionalUnits = fUnitIds;
      this.uploadAssetDialog = true;
    },
    handleSubmitAsset: function (formData) {
      let params = {
        functional_unit_ids: this.selectedFunctionalUnits.map(
          (unit) => unit.id
        ),
        ...formData,
      };
      console.log("params: ", params);
      services
        .saveAsset(params)
        .then((response) => {
          console.log(response);
          this.setSnackbar("Asset saved successfully", "success");
        })
        .catch((error) => {
          console.log("error while saving asset", error);
          this.saveAssetAlertMessage = error.message;
        });
    },
    handleSaveSuccess: function () {
      this.buildingDialog = false;
      this.setSnackbar("Functional unit saved successfully", "success");
    },
    handleComparativeOverview: function (ids) {
      router.push({ path: `/analytics/${ids}` });
    },
    handleCloseBuildingDialog: function () {
      this.buildingDialog = false;
    },
    handleCloseAssetDialog: function () {
      this.uploadAssetDialog = false;
      this.setSnackbar("Assets uploaded successfully", "success");
    },
    handleUploadAssetsFailed: function (message) {
      this.setSnackbar(message, "error");
    },
    handleDataLoaded: function () {
      this.setSnackbar();
    },
    setSnackbar: function (message, type) {
      this.snackbarMessage = message;
      this.snackbarType = type;
      this.snackbarVisible = true;
    },
  },
};
</script>

<style scoped>
.v-snack {
  top: 0;
  position: fixed;
  z-index: 9999;
}
</style>
